import { Component } from '@angular/core';
import { RoleConstants } from '@app/@shared/constants/role.constant';
import { UserPartner } from '@app/models/api/UserPartner';
import { AuthenticationService } from '@app/services/authentication.service';
import { ToolsService } from '@app/services/tools.service';
import { UserRolesService } from '@app/services/user-roles.service';
import { environment } from '@env/environment';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
})
export class SidebarComponent {
  isBcViewer = false;
  userName: string = '';
  userRoles: string[] = [];
  isLsAdmin: boolean = false;
  isDirEndUser: boolean = false;
  isLoggedIn: Boolean = false;
  version: string = '';
  menuVisible: boolean = false;
  partners: UserPartner[];

  constructor(
    private authenticationService: AuthenticationService,
    private tools: ToolsService,
    public constants: RoleConstants,
    private userRolesService: UserRolesService
  ) {
    this.authenticationService.isLoggedIn.subscribe((value) => {
      this.isLoggedIn = value;
    });

    this.tools.menuVisible.subscribe((value) => (this.menuVisible = value));
  }

  ngOnInit(): void {
    this.version = environment.version;
    this.isBcViewer = this.authenticationService.currentUserValue.isBcViewer;

    this.authenticationService.selectedPartner.subscribe((data) => {
      this.isDirEndUser = data?.isDirEnd;
    });

    this.authenticationService.currentUserSubject.subscribe((data) => {
      if (data == null) return;
      this.userRolesService.SetUser(data);
      this.userName = data?.fullname;
      this.userRoles = data?.roles;
      this.isLsAdmin = data?.isLsAdmin;
    });

    this.authenticationService.partners.subscribe((data) => {
      if (data == null) return;
      this.partners = data;
    });
  }

  sidebarMenuVisible = false;

  toggleNavbarCollapsing() {
    this.sidebarMenuVisible = !this.sidebarMenuVisible;
  }

  menuToggle: any = {
    BC: true,
    Admin: false,
  };

  togleMenuGroup(group: string) {
    this.menuToggle[group] = !this.menuToggle[group];
  }
}
